(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  /* ---------- 1. Scroll to card from URL hash ---------- */
  (() => {
    const url = new URL(window.location.href);
    if (url.hash) {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          const card = document.getElementById(url.hash.slice(1));
          if (card) {
            card.scrollIntoView({ behavior: 'instant' });
          }
        },
        { once: true }
      );
    }
  })();

  /* ---------- 2. Multi-image product card duplication ---------- */
  (() => {
    const MULTI_IMAGE_ATTRIBUTE = 'data-multi-image-duplicate';
    const PROCESSED_ATTRIBUTE = 'data-multi-image-processed';

    const getOriginalCards = (grid) =>
      Array.from(grid.children).filter(
        (card) =>
          card.matches('li.product-grid__item') &&
          !card.hasAttribute(MULTI_IMAGE_ATTRIBUTE)
      );

    const getFirstDuplicate = (grid) =>
      Array.from(grid.children).find((card) =>
        card.hasAttribute(MULTI_IMAGE_ATTRIBUTE)
      );

    const makeCloneIdsUnique = (clone, suffix) => {
      const idMap = new Map();

      clone.querySelectorAll('[id]').forEach((element) => {
        const oldId = element.id;

        if (!oldId) return;

        const newId = `${oldId}-multi-${suffix}`;

        idMap.set(oldId, newId);
        element.id = newId;
      });

      const referenceAttributes = [
        'for',
        'aria-controls',
        'aria-labelledby',
        'aria-describedby',
        'aria-owns',
      ];

      clone.querySelectorAll('*').forEach((element) => {
        referenceAttributes.forEach((attribute) => {
          const value = element.getAttribute(attribute);

          if (!value) return;

          const updatedValue = value
            .split(/\s+/)
            .map((token) => idMap.get(token) || token)
            .join(' ');

          element.setAttribute(attribute, updatedValue);
        });

        const href = element.getAttribute('href');

        if (href && href.startsWith('#')) {
          const oldId = href.slice(1);

          if (idMap.has(oldId)) {
            element.setAttribute('href', `#${idMap.get(oldId)}`);
          }
        }
      });
    };

    const getSlideshow = (card) => {
      return card.querySelector('slideshow-component');
    };

    const getSlides = (card) => {
      const slideshow = getSlideshow(card);

      if (!slideshow) return [];

      return Array.from(
        slideshow.querySelectorAll(
          'slideshow-slides > slideshow-slide'
        )
      ).filter((slide) => !slide.hasAttribute('hidden'));
    };

    const selectSlide = (card, index) => {
      const slideshow = getSlideshow(card);

      if (!slideshow) return false;

      const slides = getSlides(card);

      if (slides.length <= index) {
        return false;
      }

      /*
       * Atelier/Horizon's slideshow component exposes select().
       * Using the native component method keeps its internal state,
       * scroll position, aria-hidden state and current index synchronized.
       */
      if (typeof slideshow.select !== 'function') {
        return false;
      }

      slideshow.select(index, undefined, {
        animate: false,
      });

      return true;
    };

    const createDuplicate = (original, occurrence, originalIndex) => {
      const clone = original.cloneNode(true);

      /*
       * The original collection card has an ID based on the product ID.
       * Remove it from the duplicate so we don't create duplicate IDs.
       */
      clone.removeAttribute('id');

      /*
       * Do not allow the duplicate to be processed again.
       */
      clone.setAttribute(
        MULTI_IMAGE_ATTRIBUTE,
        String(occurrence)
      );

      clone.removeAttribute(PROCESSED_ATTRIBUTE);

      /*
       * Make IDs belonging to the product-card internals unique as well.
       */
      makeCloneIdsUnique(
        clone,
        `${originalIndex}-${occurrence}`
      );

      /*
       * The duplicate is still the exact same product card.
       * Its existing product links therefore continue to point to
       * the same Shopify product page.
       */

      return clone;
    };

    const processGrid = (grid) => {
      if (!grid) return;

      /*
       * Only process original product cards.
       * Duplicates created by this script are ignored.
       */
      const originals = getOriginalCards(grid).filter(
        (card) =>
          !card.hasAttribute(PROCESSED_ATTRIBUTE)
      );

      if (!originals.length) return;

      const secondImageClones = [];
      const thirdImageClones = [];

      originals.forEach((original, originalIndex) => {
        original.setAttribute(
          PROCESSED_ATTRIBUTE,
          'true'
        );

        const slides = getSlides(original);

        /*
         * Products with only one image remain completely unchanged.
         */
        if (slides.length < 2) {
          return;
        }

        /*
         * Create the second appearance using image #2.
         */
        const secondClone = createDuplicate(
          original,
          1,
          originalIndex
        );

        secondImageClones.push(secondClone);

        /*
         * Create the third appearance using image #3,
         * but only if the product actually has a third image.
         */
        if (slides.length >= 3) {
          const thirdClone = createDuplicate(
            original,
            2,
            originalIndex
          );

          thirdImageClones.push(thirdClone);
        }
      });

      /*
       * We want the collection to read:
       *
       * Product A - Image 1
       * Product B - Image 1
       * Product C - Image 1
       *
       * Product A - Image 2
       * Product B - Image 2
       * Product C - Image 2
       *
       * Product A - Image 3
       * Product B - Image 3
       * Product C - Image 3
       *
       * rather than:
       *
       * Product A - Image 1
       * Product A - Image 2
       * Product A - Image 3
       * Product B - Image 1
       * etc.
       */

      const firstExistingDuplicate =
        getFirstDuplicate(grid);

      /*
       * Insert all Image #2 cards before any existing
       * duplicate cards.
       */
      secondImageClones.forEach((clone) => {
        grid.insertBefore(
          clone,
          firstExistingDuplicate || null
        );
      });

      /*
       * Recalculate where the duplicate section begins.
       */
      const duplicateStart =
        getFirstDuplicate(grid);

      /*
       * Insert all Image #3 cards after the Image #2
       * section but before any older Image #3 cards.
       */
      if (duplicateStart) {
        let lastSecondImageClone = null;

        Array.from(grid.children).forEach((card) => {
          if (
            card.getAttribute(MULTI_IMAGE_ATTRIBUTE) === '1'
          ) {
            lastSecondImageClone = card;
          }
        });

        const thirdInsertPoint =
          lastSecondImageClone
            ? lastSecondImageClone.nextSibling
            : duplicateStart;

        thirdImageClones.forEach((clone) => {
          grid.insertBefore(
            clone,
            thirdInsertPoint || null
          );
        });
      } else {
        thirdImageClones.forEach((clone) => {
          grid.appendChild(clone);
        });
      }

      /*
       * Allow the duplicated custom slideshow components to
       * finish initializing before selecting their images.
       */
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          secondImageClones.forEach((clone) => {
            selectSlide(clone, 1);
          });

          thirdImageClones.forEach((clone) => {
            selectSlide(clone, 2);
          });
        });
      });
    };

    const processAllGrids = () => {
      document
        .querySelectorAll('.product-grid')
        .forEach(processGrid);
    };

    const start = () => {
      /*
       * Process products already rendered on the page.
       */
      processAllGrids();

      /*
       * Prevent multiple observers if Shopify re-renders
       * this section.
       */
      if (
        window.__touchOfEleganceMultiImageObserver
      ) {
        return;
      }

      /*
       * Atelier can load additional products through
       * infinite scroll. Watch for newly added product cards.
       */
      window.__touchOfEleganceMultiImageObserver =
        new MutationObserver((mutations) => {
          for (const mutation of mutations) {
            if (!mutation.addedNodes.length) {
              continue;
            }

            let relevantChange = false;

            for (const node of mutation.addedNodes) {
              if (!(node instanceof Element)) {
                continue;
              }

              if (
                node.matches('.product-grid') ||
                node.matches('li.product-grid__item') ||
                node.querySelector(
                  '.product-grid, li.product-grid__item'
                )
              ) {
                relevantChange = true;
                break;
              }
            }

            if (relevantChange) {
              processAllGrids();
              break;
            }
          }
        });

      window.__touchOfEleganceMultiImageObserver.observe(
        document.body,
        {
          childList: true,
          subtree: true,
        }
      );
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        start,
        { once: true }
      );
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
